import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { childmap, keymap, lccstate, userstate } from '@holmescorp/lcc-state';
import { ParentTree } from '@holmescorp/lcc-interfaces';

import { TargetViz } from './target-viz';

import css from '../css/prepost-viz.m.css';

const factory = create({ theme, lccstate, userstate });

export const TopicsetViz = factory(({ middleware: { theme, lccstate, userstate } }) => {
	const { get, path } = userstate;
	const status: ParentTree = get(path('status'));
	const roots: string[] = lccstate.get(lccstate.path('ditaroots'));

	const themeCss = theme.classes(css);
	const kids = roots
		.map((root) => {
			const tsets = childmap.get(root) || [];
			const topicsets = tsets.map((ts) => {
				const percent: number = status[ts].data.percent;
				const title: string = keymap.get(ts)!.title;
				const xqa = `topicset-viz ${ts}`;
				return w(TargetViz, { xqa, title, percent });
			});
			return v('div', { xqa: `viz ${root}`, classes: [themeCss.topicGroup] }, topicsets);
		})
		.flat();

	return v('div', { key: `root`, xqa: `viz topicset`, classes: [themeCss.root] }, kids);
});
